module.exports = __webpack_public_path__ + "static/media/international-cargo-transporter-antonov.6b36a3c7.jpg";